import React from 'react';

const FollowUp = ({ setIsDetails }) => {
    return (
        <button className='border p-2 bg-gray-200 rounded-sm hover:bg-gray-300 animation' onClick={() => setIsDetails(true)}>
            <i className="fa-solid fa-circle-info"></i>
        </button>
    )
}

export default FollowUp;